<page-banner imageUrl="page-banner-2.png" headingText="Register"></page-banner>

<div class="content-container">

  <div class="container login-container">
    <div class="row justify-content-center" *ngIf="status=='success'">
      <div class="col-md-12">
        <div class="alert alert-success rounded-0 p-2 text-center">
          <i class="fa fa-tick fa-2x"></i>
          <span>Registration successful. Please log on below with your email and specified password.</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center">
      <div class="col-md-6">
        <div class="card square-edges">
          <div class="card-body" *ngIf="!stateService.userModelValid()">
            <h1 class="h3">Register</h1>
            <p class="mt-3 font-sm">Your username will be the email address used to register</p>
            <customer-registration id="wsLogin" (onSuccess)="loginCallback($event)"></customer-registration>
          </div>
          <div class="card-body" *ngIf="stateService.userModelValid()">
            <h2>Logged in</h2>
            <button type="button">Logout</button>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    </div>
  </div>

</div>
